export default __webpack_public_path__ + "static/HeroSectionRight_es-0e9e1d94de994b1162ba4e144059a90f.png";